import { LAYOUTS, } from '@voltmoney/types';
import { SizeTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { getAutoDebitDate, getBankPNGUrl, getContactUsDetails, getParameters, horizontalStepperRepo, isFromJupiter, isIframe, removeUrlWithoutReload, ShowNewMandateError } from '../../../configs/utils';
import { changeBankAccount, changeBankAccountOnMandateFailure, contactUsAction, contactUsActionFromBE, failedVerification, goBack, hasMandateCallback, initAutoPayAction, initAutoPayActionAndroid, initInsideTataMandate, mandateCallback, needHelpAction, resetErrorModal, retryMandate, successVerification, } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { api } from "../../../configs/api";
import { getAppHeader, initializeFirebase } from "../../../configs/config";
import { Platform } from "react-native";
import { DigioMandateStatus, LENDER_ID } from "../../../configs/constants";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = (stepper, height, bankDetails, bankCode, isRedirected, isSuccessful, shouldRedirect, autoDebitDate, isFromTata, tataMandateCallback, mandateCancelled, mandateSuccess, mandateFailed, showExtraMandateError, mandateErrorData, isJupiter, lenderId, contactUsDetails, loader) => ({
    layout: {
        id: ROUTE.DIGIO_MANDATE_SIGN,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "contentSpace1", type: WIDGET.SPACE },
            { id: 'st', type: WIDGET.AUTO_PAY_LANDING_PAGE },
            { id: "contentSpace", type: WIDGET.SPACE }
        ],
    },
    datastore: {
        st: {
            height: height,
            stepperData: stepper,
            changeBankAccount: {
                type: ACTION.CHANGE_BANK_ACCOUNT,
                route: ROUTE.DIGIO_MANDATE_SIGN,
                payload: {}
            },
            goToDigioAction: isFromTata ? {
                type: ACTION.INIT_TATA_MANDATE,
                payload: {},
                routeId: ROUTE.DIGIO_MANDATE_SIGN,
            } : {
                type: ACTION.INIT,
                payload: {},
                routeId: ROUTE.DIGIO_MANDATE_SIGN,
            },
            bankDetails: bankDetails,
            bankUrl: getBankPNGUrl(bankCode),
            backAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.DIGIO_MANDATE_SIGN,
                payload: {}
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.DIGIO_MANDATE_SIGN,
                payload: {}
            },
            continuePress: {
                type: ACTION.SUCCESS_VERIFICATION,
                routeId: ROUTE.DIGIO_MANDATE_SIGN,
                payload: {}
            },
            resetErrorAction: {
                type: ACTION.RESET_ERROR_MODAL,
                routeId: ROUTE.DIGIO_MANDATE_SIGN,
                payload: {}
            },
            isRedirected: shouldRedirect ? true : isRedirected,
            isSuccessful: isSuccessful,
            autoDebitDate: autoDebitDate,
            contactUsAction: {
                type: ACTION.CONTACT_US_CARD,
                routeId: ROUTE.DIGIO_MANDATE_SIGN,
                payload: {}
            },
            digioMandateSuccess: mandateSuccess,
            digioMandateCancelled: mandateCancelled,
            digioMandateFailed: mandateFailed,
            counterDigioCancelled: Math.random(),
            loading: loader,
            showExtraMandateError: showExtraMandateError ? showExtraMandateError : false,
            mandateErrorData: mandateErrorData ? mandateErrorData : undefined,
            isJupiter: isJupiter,
            lenderId: lenderId,
            contactUsDetails: contactUsDetails,
        },
        contentSpace: { size: SizeTypeTokens.NONE },
        contentSpace1: { size: SizeTypeTokens.XS },
    },
});
export const digioMandateSignMF = {
    onLoad: async ({ getHeight, network, navigate, instrumentTrack, setDatastore }, { errorOccured, shouldRedirect, tataMandateCallback, mandateCancelled, mandateSuccess, mandateFailed, showExtraMandateError = false, mandateErrorData = undefined, setIsUserLoggedIn, setShowSupportPhoneNumber }) => {
        instrumentTrack('AUTOPAY_PAGE_VIEWED');
        await initializeFirebase();
        const showSupportPhoneNumber = await SharedPropsService.getSupportPhoneNumber();
        let loader = false;
        if (Platform.OS === 'web') {
            loader = hasMandateCallback();
            setShowSupportPhoneNumber(showSupportPhoneNumber);
        }
        const user = await network.post(api.userContext, {}, {
            headers: await getAppHeader(),
        });
        const contactUsDetails = await getContactUsDetails();
        const lenderId = user.data.linkedApplications[0].lenderAccountId;
        if (lenderId.toLowerCase() === LENDER_ID.DSP) {
            // @ts-ignore
            window?.AndroidInterface?.postMessage("DSP");
            // @ts-ignore
            window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("DSP");
            // @ts-ignore
            window?.ReactNativeWebView?.postMessage("DSP");
            window?.top?.postMessage("DSP");
        }
        if (await AsyncStorage.getItem("application_id") === null) {
            await SharedPropsService.setUser(user.data);
        }
        const isFromTataFromAPI = user.data.linkedApplications[0].lenderAccountId === "Tata";
        let isFromTataMandate = isFromTataFromAPI;
        if (tataMandateCallback) {
            isFromTataMandate = true;
        }
        await SharedPropsService.setUser(user.data);
        let isRedirected;
        let isSuccessful;
        let _showExtraMandateError = false;
        let _mandateErrorData = undefined;
        const stepper = await horizontalStepperRepo(network);
        if (shouldRedirect)
            isSuccessful = !errorOccured;
        if (Platform.OS === "web") {
            const url = Platform.OS === 'web' ? window.location.href : '';
            const params = Platform.OS === 'web' ? getParameters(url) : {};
            const digio_autopay_response = params?.digio_autopay_response;
            if (digio_autopay_response) {
                isRedirected = true;
                const user = await network.post(api.userContext, {}, {
                    headers: await getAppHeader(),
                });
                let applicationId;
                if (await AsyncStorage.getItem("application_id") !== null) {
                    applicationId = await AsyncStorage.getItem("application_id");
                }
                else {
                    applicationId = user.data.linkedApplications[0].applicationId;
                }
                removeUrlWithoutReload("digio_autopay_response");
                removeUrlWithoutReload("status");
                removeUrlWithoutReload("digio_doc_id");
                removeUrlWithoutReload("message");
                removeUrlWithoutReload("npci_txn_id");
                removeUrlWithoutReload("error_code");
                await network
                    .get(await ShowNewMandateError()
                    ? `${api.digioMandateCheckRequestStatusOnCallBackV2}${applicationId}`
                    : `${api.digioMandateCheckRequestStatusOnCallBack}${applicationId}`, {
                    headers: await getAppHeader(),
                }).then(async (response) => {
                    // ---- MANDATE ERROR CHECK CASES ---- //
                    if (await ShowNewMandateError() &&
                        response?.status === 200 &&
                        response?.data?.stepResponseObject?.status !== DigioMandateStatus.COMPLETED &&
                        response?.data?.stepResponseObject?.error !== null) {
                        isRedirected = false;
                        const errorData = response?.data?.stepResponseObject.error;
                        _showExtraMandateError = true;
                        _mandateErrorData = errorData;
                    }
                    if (await ShowNewMandateError() &&
                        response.data.stepResponseObject.status ===
                            DigioMandateStatus.COMPLETED) {
                        isSuccessful = true;
                    }
                    // ---------------------------------- //
                    else if (response.data.stepResponseObject ===
                        DigioMandateStatus.COMPLETED) {
                        isSuccessful = true;
                    }
                    else {
                        isSuccessful = false;
                    }
                });
                removeUrlWithoutReload("digio_autopay_response");
                removeUrlWithoutReload("status");
                removeUrlWithoutReload("digio_doc_id");
                removeUrlWithoutReload("message");
                removeUrlWithoutReload("npci_txn_id");
            }
            else {
                isRedirected = false;
            }
        }
        setIsUserLoggedIn(user.data);
        const response = await network
            .get(`${api.userProfile}${user.data.linkedBorrowerAccounts[0].accountId}`, { headers: await getAppHeader() });
        const bankDetails = response?.data?.bankDetails;
        const bankCode = bankDetails?.bankCode;
        const autoDebitDate = await getAutoDebitDate(network);
        if (isIframe() &&
            showExtraMandateError &&
            mandateErrorData) {
            _showExtraMandateError = true;
            _mandateErrorData = mandateErrorData;
        }
        else {
            if (Platform.OS !== 'web' &&
                showExtraMandateError &&
                mandateErrorData) {
                _showExtraMandateError = true;
                _mandateErrorData = mandateErrorData;
            }
        }
        const isJupiter = await isFromJupiter();
        return Promise.resolve(template(stepper, getHeight(), bankDetails, bankCode, isRedirected, isSuccessful, shouldRedirect, autoDebitDate, isFromTataMandate, tataMandateCallback, mandateCancelled, mandateSuccess, mandateFailed, _showExtraMandateError, _mandateErrorData, isJupiter, lenderId, contactUsDetails, loader));
    },
    actions: {
        [ACTION.INIT]: Platform.OS !== 'web' ? initAutoPayActionAndroid : initAutoPayAction,
        [ACTION.GO_BACK]: goBack,
        [ACTION.FAILED_VERIFICATION]: failedVerification,
        [ACTION.SUCCESS_VERIFICATION]: successVerification,
        [ACTION.CHANGE_BANK_ACCOUNT]: changeBankAccount,
        [ACTION.INIT_TATA_MANDATE]: initInsideTataMandate,
        [ACTION.MANDATE_CALLBACK]: mandateCallback,
        [ACTION.CONTACT_US_CARD]: contactUsAction,
        [ACTION.NEED_HELP]: needHelpAction,
        [ACTION.CONTACT_US]: contactUsActionFromBE,
        [ACTION.RETRY]: retryMandate,
        [ACTION.CHANGE]: changeBankAccountOnMandateFailure,
        [ACTION.RESET_ERROR_MODAL]: resetErrorModal,
    },
    action: {
        type: ACTION.MANDATE_CALLBACK,
        routeId: ROUTE.DIGIO_MANDATE_SIGN,
        payload: {}
    },
    clearPrevious: true,
};
